import hatsApi from '@/services/hatsApi'

const userApiUri = '/system/user'

export default {
  getUsers (filters = '', pageSize = '', currentPage = '') {
    let pagination = pageSize ? '&pageSize=' + pageSize : ''
    pagination += currentPage ? '&page=' + currentPage : ''

    return hatsApi().get(
      `${userApiUri}?filter=${JSON.stringify(filters)}${pagination}`
    )
  },
  createUser (params) {
    // TODO DARKO: Remove when BE gets updated
    params.roleId = 1
    return hatsApi().post(userApiUri, params)
  },
  editUser (id, params) {
    return hatsApi().put(`${userApiUri}/${id}`, params)
  },
  deleteUser (id) {
    return hatsApi().delete(`${userApiUri}/${id}`)
  },
  getUserById (id) {
    return hatsApi().get(`${userApiUri}/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/User.js